import '../components/landing/landing.scss'

import { Helmet } from 'react-helmet'

import Banners from '../components/landing/Banners'
import DiamondSpinner from '../components/landing/DiamondSpinner'
import Featured from '../components/landing/Featured'
import Instagram from '../components/landing/Instagram'
import Subscribe from '../components/landing/Subscribe'

function Landing() {
 

  return (
    <>
      <Helmet>
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/landing/assets/js/home_6_scripts.js"></script>
      </Helmet>


      
      <DiamondSpinner />
      <Featured />
      <Banners />
      <Subscribe />
      <Instagram />
       
    </>
  )
}

export default Landing
